import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-data-process-log',
  templateUrl: 'data-process-log.html',
})
export class DataProcessLogPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DataProcessLogPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/data-process-log/data-process-log.ts